export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5312.921813d3.jpg";